import googlePlay from "../../assets/img/google-play.png"
import appStore from "../../assets/img/app-store.png"
export default function DownloadSection() {
  return (
    <section className="download section" id="download">
      <div className="download__container container grid">
        <div className="download__content">
          <h2 className="section__title">Take Your Passion to New Heights!</h2>
          

          <div className="download__buttons">
            <a
              href="https://apps.apple.com/us/app/topgun-aviation-academy/id6738648694"
              target="_blank"
              rel="noreferrer"
            >
              <img src={appStore} /> 
</a>
            <a href="#">
                         <img src={googlePlay} /> 

            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
